import { auditRoutes } from './modules/auditRoutes';
import { authRoutes } from './modules/authRoutes';
import { coreRoutes, sportsRoutes } from './modules/coreRoutes';
import { deviceRoutes } from './modules/deviceRoutes';
import { faceRecognitionRoutes } from './modules/faceRecognitionRoutes';
import { integrationsRoutes } from './modules/integrationsRoutes';
import { monitoringRoutes } from './modules/monitoringRoutes';
import { schoolRoutes } from './modules/schoolRoutes';
import { settingsRoutes } from './modules/settingsRoutes';
import { IRouteProps } from './types';

const routes: IRouteProps[] = [
	{ type: 'title', name: 'Visão Geral', key: 'title-operacao', protected: true },
    ...coreRoutes,
    ...monitoringRoutes,
    { type: 'title', name: 'Cadastros e Gestão', key: 'title-gestao', protected: true },
    ...deviceRoutes,
    ...faceRecognitionRoutes,
    ...schoolRoutes,
    ...sportsRoutes,
    { type: 'title', name: 'Inteligência', key: 'title-auditoria', protected: true },
    ...auditRoutes,
    { type: 'title', name: 'Sistema', key: 'title-sistema', protected: true },
    ...integrationsRoutes,
    ...settingsRoutes,
	...authRoutes,
];

export default routes;
export type { IRouteProps };
